import React from 'react'
import { CaptionText, BodyText, Button, Row, Col } from '@paypalcorp/pp-react'
import PropTypes from 'prop-types'
import './index.css'
import { getLocalizedText } from 'ppbl/utils/locale-helper'

const AddressCard = ({ addressFields, handleButtonClick, addressType }) => {
  return (
    <div className="card" data-dd-privacy="mask">
      <div className="card_text_area">
        <Row>
          <CaptionText className="card_caption_text texts">
            {addressType}
          </CaptionText>
        </Row>
        <Row>
          <Col>
            {Object.keys(addressFields).map(
              (key, index) =>
                !!addressFields[key] && (
                  <BodyText key={index}>{addressFields[key]}</BodyText>
                ),
            )}
          </Col>
        </Row>
        <Row>
          <CaptionText className="card_caption_text texts">
            {getLocalizedText('components.addressCard.helperText')}
          </CaptionText>
        </Row>
      </div>
      <div>
        <Button onClick={handleButtonClick} tertiary>
          {getLocalizedText('components.addressCard.changeBtn')}
        </Button>
      </div>
    </div>
  )
}

AddressCard.propTypes = {
  addressFields: PropTypes.object,
  handleButtonClick: PropTypes.func,
  addressType: PropTypes.string,
}

export default AddressCard
